import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { BookingExtendedView } from 'cb-model';
import { fetchApi, makeResetCache, selectUser, useCacheQuery } from 'gossamer-front-end';
import { CaptureEventFeedbackForm } from './CaptureEventFeedbackForm';

export const CaptureEventFeedback = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eventId } = useParams<{ eventId: string }>();
  const numericEventId = Number(eventId || '');
  const bookingQuery = useCacheQuery(
    BookingExtendedView,
    {
      where: {
        and: [
          { fieldId: 'event_id', operator: 'eq', value: numericEventId },
          { fieldId: 'user_id', operator: 'eq', value: user?.userId },
          { fieldId: 'booking_status', operator: 'eq', value: 'active' },
        ],
      },
      limit: 1,
    },
    !user?.userId || !numericEventId,
  );

  const booking = bookingQuery.data?.[0];
  if (!numericEventId) {
    return <div>Event ID is missing in the URL</div>;
  }
  if (!user) {
    return <div>Loading user...</div>;
  }
  if (bookingQuery.error) {
    return <div>An error occurred while loading booking data ({bookingQuery.error})</div>;
  }
  if (bookingQuery.data && !booking) {
    return <div>Booking not found</div>;
  }
  if (!booking) {
    return <div>Loading booking data...</div>;
  }

  const handleSubmit = async (data: any) => {
    data.eventId = numericEventId;
    data.feedbackFormId = data.feedbackFormId || 1;
    const response = await fetchApi('POST', '/main/submit-event-feedback', data);
    if (response.status === 200 && !response.error) {
      makeResetCache(dispatch)('BookingExtendedView', String(booking.ticket_booking_id));
      window.scrollTo({
        top: 0,
      });
      navigate(`/website/event-feedback-success/${booking.ticket_booking_id}`);
    } else if (response.error) {
      console.error('Error submitting feedback:', response.error);
      alert(`Failed to submit feedback: ${response.error}`);
    }
  };

  return (
    <div>
      <CaptureEventFeedbackForm
        eventId={numericEventId}
        title={booking?.title}
        onSubmit={handleSubmit}
        feedbackFormId={booking.feedback_form_id || null}
      />
    </div>
  );
};
